import { styled } from "styled-components";

export const InputStyled = styled.div`
  display: flex;
  flex-direction: column;

  width: 20%;
  max-width: 350px;
`;
